<script setup lang="ts">
import { MenuItems } from "@headlessui/vue";
</script>

<template>
  <MenuItems class="dropdown-menu">
    <slot></slot>
  </MenuItems>
</template>

<style lang="scss" scoped>
.dropdown-menu {
  position: absolute;
  left: 0;
  z-index: 1000;
  width: auto;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: var(--main-border-radius);
  background-color: var(--menu-body-background-color);
  list-style: none;
  color: var(--menu-body-text-color);
  white-space: nowrap;

  margin-top: 5px;
  padding: 0.3rem;
}
</style>
